import RentReliefReductions from '../../components/rent-relief-reductions/rent-relief-reductions.vue';

export default {
  name: 'rent-relief-reduction-container',
  components: {
    RentReliefReductions,
  },
  data() {
    return {
      isReductionsValid: false,
    };
  },
  methods: {
    backStep() {
      this.$emit('backStep');
    },
    nextStep() {
      this.$emit('nextStep');
    },
    reductionsValid(value) {
      this.isReductionsValid = value;
    },
    isInvalid() {
      return !this.isReductionsValid;
    },
  },
};
